import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Radio, RadioGroup } from 'appkit-react';

const ExtremeText = ({ data = [] }) => (
  <div className="sub-text">
    {data.map((d) => (
      <div>{d}</div>
    ))}
  </div>
);

const ScaleBar = (props, ref) => {
  const {
    values: propsValue,
    options: { count = 6, extremeTexts = [] } = {},
    disabled,
  } = props;

  const [value, setValue] = useState(String(propsValue?.choice || -1));

  useImperativeHandle(ref, () => ({
    getValues: () => ({
      choice: value >= 0 ? value : null,
    }),
  }));

  const onChange = (_, v) => {
    setValue(v);
  };
  return (
    <div className="question-scalebar-wrapper">
      <ExtremeText data={extremeTexts} />
      <RadioGroup
        onChange={onChange}
        value={value}
        className="question-scalebar"
      >
        {Array.from(new Array(count)).map((o, i) => (
          <Radio disabled={disabled} key={i} value={String(i + 1)} />
        ))}
      </RadioGroup>
    </div>
  );
};

export default forwardRef(ScaleBar);
